<template>
  <div class="configuration-modal-wrapper" :class="position">
    <CustomModal @onClose="onClose">
      <div class="iframe-wrapper">
        <iframe ref="htmlFrame"></iframe>
      </div>
      <div class="loading-container" v-if="isLoading">
        <LoadingSpinner
          loadingCaption="Vorschau wird geladen..."
          v-show="isLoading"
        />
      </div>
    </CustomModal>
  </div>
</template>
<script>
import CustomModal from '@/components/modals/CustomModal.vue';
import LoadingSpinner from '@/components/widgets/LoadingSpinner.vue';
import { generatePdf } from '@/services/workflow.service';
export default {
  name: 'OptionPopupModal',
  data() {
    return {
      isLoading: true,
    };
  },
  props: {
    htmlString: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: 'middle',
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    loadHTML(htmlString) {
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        // Find and remove the div with class "menu-list"
        const menuList = doc.querySelector('#codelos-page-menu');
        if (menuList) {
          menuList.remove();
        }

        // Get the cleaned HTML back
        const cleanedHTML = doc.documentElement.outerHTML;

        // Inject into iframe
        const iframe = this.$refs.htmlFrame;
        const iframeDoc = iframe?.contentWindow?.document;
        iframeDoc.open();
        iframeDoc.write(cleanedHTML);
        iframeDoc.close();
      } catch (error) {
        console.log('loadHTML error', error);
      }
    },
    async retriveHtmlContent() {
      try {
        this.isLoading = true;
        const payload = {
          content: this.htmlString || '',
          values: [],
          htmlOnly: true,
        };
        console.log('payload', payload);
        const response = await generatePdf(payload);
        const htmlContent = response?.data?.data || '';
        this.loadHTML(htmlContent);
      } catch (error) {
        console.log('retriveHtml error', error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.retriveHtmlContent();
  },

  components: { CustomModal, LoadingSpinner },
};
</script>
<style scoped>
.configuration-modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.configuration-modal-wrapper
  ::v-deep
  .custom-modal-wrapper
  .custom-modal-backdrop {
  background-color: rgba(0, 0, 0, 0.39) !important;
}

.configuration-modal-wrapper ::v-deep .custom-modal-wrapper .custom-modal {
  width: calc(100% - 250px);
  height: calc(100% - 200px);
}
.configuration-modal-wrapper .iframe-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
}

.configuration-modal-wrapper .iframe-wrapper iframe {
  width: 100%;
  height: 100%;
  border: none;
}

/* right side modal css  */
.configuration-modal-wrapper.right ::v-deep .custom-modal-wrapper {
  padding: 0;
  display: flex;
  justify-content: flex-end;
}
.configuration-modal-wrapper.left ::v-deep .custom-modal-wrapper {
  padding: 0;
  display: flex;
  justify-content: flex-start;
}

.configuration-modal-wrapper.left ::v-deep .custom-modal-wrapper .custom-modal,
.configuration-modal-wrapper.right
  ::v-deep
  .custom-modal-wrapper
  .custom-modal {
  width: 50%;
  height: 100%;
  border-radius: 0;
}

.configuration-modal-wrapper .loading-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 11;
}
.configuration-modal-wrapper .loading-container ::v-deep .loading {
  border-radius: 20px;
}

@media (max-width: 768px) {
  .configuration-modal-wrapper ::v-deep .custom-modal-wrapper .custom-modal {
    width: 100% !important;
  }
}
</style>
